{
  "fr": {
    "materials": {
      "collectionEmpty": {
        "communityTab": "Regarde dans le matériel de la communauté fobizz.",
        "partnerTab": "Regarde dans le matériel de fobizz & partenaires.",
        "title": "Rien trouvé ?",
        "viewCommunityMaterial": "Vers le matériel de la communauté fobizz",
        "viewPartnerMaterial": "Vers le matériel de fobizz & partenaires"
      },
      "collectionTeaser": {
        "linkName": "En savoir plus",
        "title": "Plans de cours complets dans les collections"
      },
      "filters": {
        "language": "Langue",
        "order": {
          "label": "Trier par",
          "newest": "Les plus récents",
          "relevance": "Pertinence"
        }
      },
      "galleryTeaser": {
        "linkName": "En savoir plus",
        "title": "Comment utiliser au mieux les matériaux de la galerie"
      },
      "headings": {
        "toTeach": "Ces contenus proviennent de notre <a href=\"https://app.fobizz.com/partners/34-to-teach\" target=\"_blank\">partenaire to teach</a>. Avec un compte to teach gratuit, vous pouvez utiliser de manière illimitée les contenus existants de to teach et en créer 10 nouveaux par mois. <a href=\"https://app.fobizz.com/de/help/articles/271-to-teach-abo-kostenlos\" target=\"_blank\">En savoir plus.</a>"
      },
      "howTo": {
        "header": {
          "heading": "La galerie fobizz - ce qui vous attend",
          "list_html": "<li><i class='bi bi-check-lg'></i>Inspiration d'autres enseignants pour votre cours</li>\n<li><i class='bi bi-check-lg'></i>Matériaux pratiques et gratuits à réutiliser</li>\n<li><i class='bi bi-check-lg'></i>Adaptation facile des modèles et exemples avec les outils fobizz</li>\n<li><i class='bi bi-check-lg'></i>Gain de temps grâce à l'échange de matériaux et d'idées de cours</li>\n<li><i class='bi bi-check-lg'></i>Collections avec des plans de cours prêts sur des sujets spécifiques</li>"
        },
        "recommendations": {
          "heading": "Découvrez les collections actuelles"
        },
        "terms": {
          "collections": {
            "description_html": "Dans la galerie, vous trouverez des collections de matériel pédagogique <strong>sur des sujets spécifiques</strong>. Vous pouvez choisir des éléments individuels et les adapter ou utiliser directement <strong>des plans de cours complets</strong> avec tous les matériaux nécessaires en classe.",
            "heading": "Collections ?"
          },
          "copyright": {
            "description_html": "Dans l'esprit des <strong>OER</strong> (Open Educational Resources), tous les contenus publiés par les enseignants dans la galerie sont sous la <a href=\"https://creativecommons.org/licenses/by/3.0/de/\" target=\"_blank\">licence Creative Commons CC-BY</a>. Cela signifie que vous pouvez les utiliser, les modifier et les diffuser gratuitement.",
            "heading": "Droits d'auteur ?"
          },
          "description": "Les termes suivants apparaissent dans la galerie. Découvrez ce qu'ils signifient ici !",
          "heading": "Qu'en est-il de...",
          "link": "Découvrez maintenant le matériel pédagogique",
          "remix": {
            "description_html": "Avec un simple clic sur le <strong>bouton Remix</strong>, vous pouvez copier chaque matériel de la galerie dans votre <strong>propre dossier</strong> - comme un modèle de copie numérique. Utilisez le matériel directement en classe ou adaptez des éléments individuels avant utilisation.",
            "heading": "Remix ?"
          }
        },
        "tile": {
          "heading": "Trouvez des contenus qui vous conviennent parfaitement",
          "help": {
            "author": "Auteur·e du matériel",
            "bookmark": "Cœur pour votre liste de favoris",
            "kind": "Type de contenu"
          },
          "link": "Retour à la galerie",
          "list_html": "<li><i class='bi bi-check-lg'></i>Recherchez par <strong>thèmes et mots-clés</strong> et affinez les résultats : par type d'école recommandé, groupe d'âge ou matière.</li>\n<li><i class='bi bi-check-lg'></i>Enregistrez des contenus intéressants pour plus tard en cliquant sur le cœur et retrouvez-les dans votre <strong>liste de favoris personnelle</strong>.</li>\n<li><i class='bi bi-check-lg'></i>Évaluez la <strong>popularité d'un matériel</strong> en un coup d'œil. Avec le nombre de remixes, vous voyez à quelle fréquence il a déjà été réutilisé.</li>",
          "material_title": "Plus jamais de devoirs ? IA - Possibilités et limites"
        },
        "title": "Tout ce qu'il faut savoir sur la galerie"
      },
      "labels": {
        "approvedUserIds": "Partenaires",
        "filterCollection": "Collection",
        "galleryCommunityPlaceholder": "Rechercher dans le matériel de la communauté fobizz",
        "galleryFallbackPlaceholder": "Rechercher des contenus",
        "galleryPlaceholder": "Rechercher dans le matériel de fobizz & partenaires",
        "galleryToTeachPlaceholder": "Rechercher des contenus to teach",
        "models": "Types de matériel"
      },
      "searchPlaceholder": "Rechercher dans le matériel fobizz...",
      "toTeachImport": {
        "importing": "Importation de la fiche...",
        "importingDescription": "Votre fiche to teach est en cours de conversion en fiche fobizz. Cela peut prendre un moment.",
        "importFailed": "Échec de l'importation. Veuillez réessayer.",
        "importNotFound": "La fiche n'a pas été trouvée.",
        "importQueued": "Votre fiche est en cours d'importation en arrière-plan.",
        "importReady": "Votre fiche to teach a été importée avec succès !"
      },
      "subNav": {
        "community": "Communauté fobizz",
        "fobizz": "fobizz & partenaires",
        "toTeach": "Contenus to teach"
      }
    }
  }
}
